export default __webpack_public_path__ + "static/media/laptop (1).bef72af2.png";